var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isStatusLoading
    ? _c(
        "div",
        [
          _c("div", { staticClass: "text-center mb-3" }, [
            _vm._v(_vm._s(_vm.loadingText)),
          ]),
          _vm._v(" "),
          _c("LoadingAnimation", { attrs: { "animation-style": "bars" } }),
        ],
        1
      )
    : _c(
        "div",
        {
          staticClass: "w-100 d-flex justify-content-center flex-wrap",
          staticStyle: { gap: "80px" },
        },
        [
          _c(
            "div",
            { staticClass: "user-modal-choose-payment-view px-4" },
            [
              _c("p", { staticClass: "font-weight-bold font-size-175 mb-0" }, [
                _vm._v("\n            " + _vm._s(_vm.titleText) + "\n        "),
              ]),
              _vm._v(" "),
              _vm.stripePaymentIntent !== ""
                ? _c("ChoosePayment", {
                    ref: "choosePayment",
                    attrs: {
                      disabled: _vm.isSubmitting,
                      "stripe-payment-intent": _vm.stripePaymentIntent,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex justify-content-between" },
                _vm._l(_vm.dueText, function (text) {
                  return _c("strong", {
                    staticClass: "font-size-125",
                    domProps: { innerHTML: _vm._s(text) },
                  })
                }),
                0
              ),
              _vm._v(" "),
              _c("ButtonWithLoadingState", {
                staticClass:
                  "btn btn-success btn-lg btn-block font-weight-bold font-size-125 rounded d-flex justify-content-center gap-10",
                attrs: {
                  "data-user-modal-button-submit": "",
                  icon: "fa fa-arrow-right lh-1",
                  text: _vm.submitButtonText,
                  "is-state-loading": _vm.isSubmitting,
                  disabled: !_vm.productSlug,
                  "show-icon-after-text": true,
                },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.doPayment.apply(null, arguments)
                  },
                },
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "text-muted small",
                domProps: { innerHTML: _vm._s(_vm.postSubmitButtonText) },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.onBottomTextClicked.apply(null, arguments)
                  },
                },
              }),
              _vm._v(" "),
              _vm.isSale &&
              this.selectedBilling ===
                "annual_%currency%_%version%_sale_cyberweek"
                ? _c("div", {
                    staticClass: "text-center small",
                    domProps: { innerHTML: _vm._s(_vm.payNowTextSale) },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.onBottomTextClicked.apply(null, arguments)
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass:
                    "position-relative btn paypal-gold btn-lg btn-block font-weight-bold text-uppercase rounded",
                  attrs: {
                    "data-user-modal-input-provider-paypal": "",
                    disabled: _vm.isSubmitting || !_vm.productSlug,
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.payPalPayment.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm.isSubmitting
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "position-absolute d-flex top-0 left-0 h-100 w-100 align-items-center justify-content-center",
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-spin btn-loading-animation",
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", {}, [
                    _c(
                      "svg",
                      {
                        staticClass: "w-auto",
                        attrs: {
                          height: "28px",
                          width: "115px",
                          viewBox: "0 0 123.59 30.18",
                        },
                      },
                      [
                        _c("g", [
                          _c("path", {
                            attrs: {
                              fill: "#253B80",
                              d: "M46.211,6.749h-6.839c-0.468,0-0.866,0.34-0.939,0.802l-2.766,17.537c-0.055,0.346,0.213,0.658,0.564,0.658\n                            h3.265c0.468,0,0.866-0.34,0.939-0.803l0.746-4.73c0.072-0.463,0.471-0.803,0.938-0.803h2.165c4.505,0,7.105-2.18,7.784-6.5\n                            c0.306-1.89,0.013-3.375-0.872-4.415C50.224,7.353,48.5,6.749,46.211,6.749z M47,13.154c-0.374,2.454-2.249,2.454-4.062,2.454\n                            h-1.032l0.724-4.583c0.043-0.277,0.283-0.481,0.563-0.481h0.473c1.235,0,2.4,0,3.002,0.704C47.027,11.668,47.137,12.292,47,13.154z",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              fill: "#253B80",
                              d: "M66.654,13.075h-3.275c-0.279,0-0.52,0.204-0.563,0.481l-0.145,0.916l-0.229-0.332\n                            c-0.709-1.029-2.29-1.373-3.868-1.373c-3.619,0-6.71,2.741-7.312,6.586c-0.313,1.918,0.132,3.752,1.22,5.031\n                            c0.998,1.176,2.426,1.666,4.125,1.666c2.916,0,4.533-1.875,4.533-1.875l-0.146,0.91c-0.055,0.348,0.213,0.66,0.562,0.66h2.95\n                            c0.469,0,0.865-0.34,0.939-0.803l1.77-11.209C67.271,13.388,67.004,13.075,66.654,13.075z M62.089,19.449\n                            c-0.316,1.871-1.801,3.127-3.695,3.127c-0.951,0-1.711-0.305-2.199-0.883c-0.484-0.574-0.668-1.391-0.514-2.301\n                            c0.295-1.855,1.805-3.152,3.67-3.152c0.93,0,1.686,0.309,2.184,0.892C62.034,17.721,62.232,18.543,62.089,19.449z",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              fill: "#253B80",
                              d: "M84.096,13.075h-3.291c-0.314,0-0.609,0.156-0.787,0.417l-4.539,6.686l-1.924-6.425\n                            c-0.121-0.402-0.492-0.678-0.912-0.678h-3.234c-0.393,0-0.666,0.384-0.541,0.754l3.625,10.638l-3.408,4.811\n                            c-0.268,0.379,0.002,0.9,0.465,0.9h3.287c0.312,0,0.604-0.152,0.781-0.408L84.564,13.97C84.826,13.592,84.557,13.075,84.096,13.075z\n                            ",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              fill: "#179BD7",
                              d: "M94.992,6.749h-6.84c-0.467,0-0.865,0.34-0.938,0.802l-2.766,17.537c-0.055,0.346,0.213,0.658,0.562,0.658\n                            h3.51c0.326,0,0.605-0.238,0.656-0.562l0.785-4.971c0.072-0.463,0.471-0.803,0.938-0.803h2.164c4.506,0,7.105-2.18,7.785-6.5\n                            c0.307-1.89,0.012-3.375-0.873-4.415C99.004,7.353,97.281,6.749,94.992,6.749z M95.781,13.154c-0.373,2.454-2.248,2.454-4.062,2.454\n                            h-1.031l0.725-4.583c0.043-0.277,0.281-0.481,0.562-0.481h0.473c1.234,0,2.4,0,3.002,0.704\n                            C95.809,11.668,95.918,12.292,95.781,13.154z",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              fill: "#179BD7",
                              d: "M115.434,13.075h-3.273c-0.281,0-0.52,0.204-0.562,0.481l-0.145,0.916l-0.23-0.332\n                            c-0.709-1.029-2.289-1.373-3.867-1.373c-3.619,0-6.709,2.741-7.311,6.586c-0.312,1.918,0.131,3.752,1.219,5.031\n                            c1,1.176,2.426,1.666,4.125,1.666c2.916,0,4.533-1.875,4.533-1.875l-0.146,0.91c-0.055,0.348,0.213,0.66,0.564,0.66h2.949\n                            c0.467,0,0.865-0.34,0.938-0.803l1.771-11.209C116.053,13.388,115.785,13.075,115.434,13.075z M110.869,19.449\n                            c-0.314,1.871-1.801,3.127-3.695,3.127c-0.949,0-1.711-0.305-2.199-0.883c-0.484-0.574-0.666-1.391-0.514-2.301\n                            c0.297-1.855,1.805-3.152,3.67-3.152c0.93,0,1.686,0.309,2.184,0.892C110.816,17.721,111.014,18.543,110.869,19.449z",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              fill: "#179BD7",
                              d: "M119.295,7.23l-2.807,17.858c-0.055,0.346,0.213,0.658,0.562,0.658h2.822c0.469,0,0.867-0.34,0.939-0.803\n                            l2.768-17.536c0.055-0.346-0.213-0.659-0.562-0.659h-3.16C119.578,6.749,119.338,6.953,119.295,7.23z",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              fill: "#253B80",
                              d: "M7.266,29.154l0.523-3.322l-1.165-0.027H1.061L4.927,1.292C4.939,1.218,4.978,1.149,5.035,1.1\n                            c0.057-0.049,0.13-0.076,0.206-0.076h9.38c3.114,0,5.263,0.648,6.385,1.927c0.526,0.6,0.861,1.227,1.023,1.917\n                            c0.17,0.724,0.173,1.589,0.007,2.644l-0.012,0.077v0.676l0.526,0.298c0.443,0.235,0.795,0.504,1.065,0.812\n                            c0.45,0.513,0.741,1.165,0.864,1.938c0.127,0.795,0.085,1.741-0.123,2.812c-0.24,1.232-0.628,2.305-1.152,3.183\n                            c-0.482,0.809-1.096,1.48-1.825,2c-0.696,0.494-1.523,0.869-2.458,1.109c-0.906,0.236-1.939,0.355-3.072,0.355h-0.73\n                            c-0.522,0-1.029,0.188-1.427,0.525c-0.399,0.344-0.663,0.814-0.744,1.328l-0.055,0.299l-0.924,5.855l-0.042,0.215\n                            c-0.011,0.068-0.03,0.102-0.058,0.125c-0.025,0.021-0.061,0.035-0.096,0.035H7.266z",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              fill: "#179BD7",
                              d: "M23.048,7.667L23.048,7.667L23.048,7.667c-0.028,0.179-0.06,0.362-0.096,0.55\n                            c-1.237,6.351-5.469,8.545-10.874,8.545H9.326c-0.661,0-1.218,0.48-1.321,1.132l0,0l0,0L6.596,26.83l-0.399,2.533\n                            c-0.067,0.428,0.263,0.814,0.695,0.814h4.881c0.578,0,1.069-0.42,1.16-0.99l0.048-0.248l0.919-5.832l0.059-0.32\n                            c0.09-0.572,0.582-0.992,1.16-0.992h0.73c4.729,0,8.431-1.92,9.513-7.476c0.452-2.321,0.218-4.259-0.978-5.622\n                            C24.022,8.286,23.573,7.945,23.048,7.667z",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              fill: "#222D65",
                              d: "M21.754,7.151c-0.189-0.055-0.384-0.105-0.584-0.15c-0.201-0.044-0.407-0.083-0.619-0.117\n                            c-0.742-0.12-1.555-0.177-2.426-0.177h-7.352c-0.181,0-0.353,0.041-0.507,0.115C9.927,6.985,9.675,7.306,9.614,7.699L8.05,17.605\n                            l-0.045,0.289c0.103-0.652,0.66-1.132,1.321-1.132h2.752c5.405,0,9.637-2.195,10.874-8.545c0.037-0.188,0.068-0.371,0.096-0.55\n                            c-0.313-0.166-0.652-0.308-1.017-0.429C21.941,7.208,21.848,7.179,21.754,7.151z",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              fill: "#253B80",
                              d: "M9.614,7.699c0.061-0.393,0.313-0.714,0.652-0.876c0.155-0.074,0.326-0.115,0.507-0.115h7.352\n                            c0.871,0,1.684,0.057,2.426,0.177c0.212,0.034,0.418,0.073,0.619,0.117c0.2,0.045,0.395,0.095,0.584,0.15\n                            c0.094,0.028,0.187,0.057,0.278,0.086c0.365,0.121,0.704,0.264,1.017,0.429c0.368-2.347-0.003-3.945-1.272-5.392\n                            C20.378,0.682,17.853,0,14.622,0h-9.38c-0.66,0-1.223,0.48-1.325,1.133L0.01,25.898c-0.077,0.49,0.301,0.932,0.795,0.932h5.791\n                            l1.454-9.225L9.614,7.699z",
                            },
                          }),
                        ]),
                      ]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "w-100 position-relative" },
                [
                  _c("Transition", { attrs: { name: "fade-grow-slow" } }, [
                    _vm.showRefundInfo
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "border bg-white rounded position-absolute w-100 bottom-0 shadow",
                            staticStyle: {
                              "max-width": "404px",
                              "z-index": "100",
                              left: "50%",
                              transform: "translate(-50%, 0)",
                            },
                          },
                          [
                            _c("div", { staticClass: "transition-header" }, [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "font-size-125 font-weight-bold position-relative m-0",
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm._f("trans")("Refund policy")) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "cursor-pointer font-size-150",
                                  attrs: {
                                    "data-user-modal-payment-refund-info-close":
                                      "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      $event.preventDefault()
                                      _vm.showRefundInfo = false
                                    },
                                  },
                                },
                                [_vm._v("×")]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticStyle: { padding: "1rem" } }, [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("trans")(
                                      "You can request a full refund within 14 days after you subscribed with no questions asked. Please contact our support team for assistance."
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "mb-0" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("trans")(
                                      "Please note that you are not eligible for a refund anymore after 14 days."
                                    )
                                  )
                                ),
                              ]),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("Transition", { attrs: { name: "fade-grow-slow" } }, [
                    _vm.showCancelInfo
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "border bg-white rounded position-absolute w-100 bottom-0 shadow",
                            staticStyle: {
                              "max-width": "404px",
                              "z-index": "100",
                              left: "50%",
                              transform: "translate(-50%, 0)",
                            },
                          },
                          [
                            _c("div", { staticClass: "transition-header" }, [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "font-size-125 font-weight-bold position-relative m-0",
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm._f("trans")(
                                          "Cancel the subscription at any time"
                                        )
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "cursor-pointer font-size-150",
                                  attrs: {
                                    "data-user-modal-payment-cancel-info-close":
                                      "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      $event.preventDefault()
                                      _vm.showCancelInfo = false
                                    },
                                  },
                                },
                                [_vm._v("×")]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticStyle: { padding: "1rem" } }, [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("trans")(
                                      "In order to cancel your subscription, please login and go to your dashboard."
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "mb-0" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("trans")(
                                      "You will be able to use the service after cancellation for the amount of time you have already paid for. You can reactivate your subscription later at any time."
                                    )
                                  )
                                ),
                              ]),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _vm.showBackButton
                ? _c(
                    "div",
                    { staticClass: "d-flex justify-content-center" },
                    [
                      _c("ButtonWithLoadingState", {
                        staticClass:
                          "position-relative btn font-weight-bold font-size-125 text-uppercase rounded",
                        attrs: {
                          icon: "fa fa-arrow-left lh-1",
                          text: _vm.backButtonText,
                          "is-state-loading": _vm.isSubmitting,
                          disabled: !_vm.productSlug,
                          "show-icon-after-text": false,
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.goBack.apply(null, arguments)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("Transition", { attrs: { name: "fade-fast" } }, [
                _vm.showCancelInfo || _vm.showRefundInfo
                  ? _c("div", {
                      staticClass:
                        "position-absolute w-100 h-100 top-0 left-0 bg-modal",
                      staticStyle: {
                        "z-index": "99",
                        "box-shadow": "0 0 2000px 2000px rgb(0 0 0 / 50%)",
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          _vm.showRefundInfo = false
                          _vm.showCancelInfo = false
                        },
                      },
                    })
                  : _vm._e(),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("YourPlan"),
        ],
        1
      )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { attrs: { id: "smart-button-container" } }, [
      _c("div", { staticStyle: { "text-align": "center" } }, [
        _c("div", { attrs: { id: "paypal-button-container" } }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }